import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


import home from '../views/home.vue'

const router = new Router({
	routes: [{
		path: '/',
		name: 'Home',
		meta: {
			title: 'Home',
		},
		component: home,// resolve => require(['../views/home.vue'], resolve)
	},
	{
		path: '/organizers',
		name: 'Organisers',
		meta: {
			title: 'Organisers',
		},
		component: resolve => require(['../views/organizers.vue'], resolve)
	},
	{
		path: '/sponsorList',
		name: 'sponsorList',
		meta: {
			title: 'sponsor List',
		},
		component: resolve => require(['../views/sponsorList.vue'], resolve)
	},
	{
		path: '/videoList',
		name: 'videoList',
		meta: {
			title: 'video List',
		},
		component: resolve => require(['../views/videoList.vue'], resolve)
	},
	{
		path: '/newsList',
		name: 'newsList',
		meta: {
			title: 'news List',
		},
		component: resolve => require(['../views/newsList.vue'], resolve)
	},
	{
		path: '/video',
		name: 'video',
		meta: {
			title: 'video',
		},
		component: resolve => require(['../views/video.vue'], resolve)
	},
	{
		path: '/newsDetail',
		name: 'newsDetail',
		meta: {
			title: 'news Detail',
		},
		component: resolve => require(['../views/newsDetail.vue'], resolve)
	},
	{
		path: '/gaIcm',
		name: 'Congress',
		meta: {
			title: 'Congress',
		},
		component: resolve => require(['../views/gaIcm.vue'], resolve)
	},
	{
		path: '/resource',
		name: 'resource',
		meta: {
			title: 'resource',
		},
		component: resolve => require(['../views/resource.vue'], resolve)
	},
	{
		path: '/comprehensiveSupport',
		name: 'Support',
		meta: {
			title: 'Support',
		},
		component: resolve => require(['../views/comprehensiveSupport.vue'], resolve)
	},
	{
		path: '/why',
		name: 'Hong Kong',
		meta: {
			title: 'Hong Kong',
		},
		component: resolve => require(['../views/why.vue'], resolve)
	},
	],
})

// 重写 push 解决重复导航报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

import { getLocationInfo } from '../utils/location'
router.afterEach((to, from) => {
	// 如果进入的是/，则滚动到顶部
	// if (to.path != '/') {
	Vue.nextTick(() => {
		try {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		} catch (e) {
			window.scrollTo(0, 0)
		}
	})
	// }
})
router.beforeEach(async (to, from, next) => {
	// 仅首次进入 / 页面刷新 / 全新路由跳转 执行
	try {
		await getLocationInfo(to) // 执行接口请求
	} catch (err) {
		console.error('位置接口请求失败', err)
	}
	next()
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js